// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox_keto_container__3f-cr","selected":"CheckBox_keto_selected__WAUR-","customSizeSpan":"CheckBox_keto_customSizeSpan__1QjuY"};